import { Wordmark } from '@mcgames/ui';
import type { ReactNode } from 'react';
import { LanguageSwitch } from './LanguageSwitch.tsx';
import styles from './PublicLayout.module.css';

export type PublicLayoutProps = {
  children: ReactNode;
  /** Wider content column for pages that list more than a form. */
  wide?: boolean;
};

/** Frame of the pages that work without a session: wordmark, language switch, one centered column. */
export function PublicLayout({ children, wide = false }: PublicLayoutProps) {
  return (
    <div className={styles['page']}>
      <header className={styles['header']}>
        <Wordmark />
        <LanguageSwitch />
      </header>
      <main className={[styles['main'], wide ? styles['wide'] : ''].filter(Boolean).join(' ')}>
        {children}
      </main>
    </div>
  );
}
